/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import React from 'react';
import { IPoNumberViewProps } from './po-number';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

export default (props: IPoNumberViewProps) => {
    const {
        poNumberWrapperProps,
        poNumberLabelProps,
        poNumberInputProps,
        staticPoNumberDisplay,
        resources: { poNumberLabel },
        error,
        viewState,
        poValidationMessage,
        isPoValidationMessage
    } = props;
    return (
        <Module {...poNumberWrapperProps}>
            {viewState.isError && error}
            {viewState.isShowList ? (
                <React.Fragment>
                    <Node {...poNumberLabelProps} key={'po-num-label'}>
                        {poNumberLabel}
                    </Node>
                    <Node {...poNumberInputProps} key={'po-num-input'} />
                </React.Fragment>
            ) : null}
            {isPoValidationMessage && poValidationMessage}
            {viewState.isShowSelected ? staticPoNumberDisplay : null}
        </Module>
    );
};
